// src/data/quizzes/land_military_rangs/ticketsData.js

export const ticketsData = [
  {
    id: 1,
    image: '/tickets/land_miliraty_rangs/ordinary_cadet.png',
    question: 'Что за ранг?',
    correctAnswer: 'Рядовой (курсант)',
    hint: 'Погоны абсолютно чистые — ни звёзд, ни полосок. Самый первый шаг в военной иерархии, с него начинается путь воина.'
  },
  {
    id: 2,
    image: '/tickets/land_miliraty_rangs/corporal.png',
    question: 'Что за ранг?',
    correctAnswer: 'Ефрейтор',
    hint: 'Единственная узкая поперечная полоска на погоне. Первый знак отличия за усердие, но ещё не командир.'
  },
  {
    id: 3,
    image: '/tickets/land_miliraty_rangs/junior_sergeant.png',
    question: 'Что за ранг?',
    correctAnswer: 'Младший сержант',
    hint: 'Две узкие поперечные полоски. Самый младший из тех, кто уже может командовать.'
  },
  {
    id: 4,
    image: '/tickets/land_miliraty_rangs/sergeant.png',
    question: 'Что за ранг?',
    correctAnswer: 'Сержант',
    hint: 'Три поперечные полоски — максимум для этого уровня. Опытный наставник для новобранцев.'
  },
  {
    id: 5,
    image: '/tickets/land_miliraty_rangs/senior_sergeant.png',
    question: 'Что за ранг?',
    correctAnswer: 'Старший сержант',
    hint: 'Одна широкая поперечная полоска вместо нескольких узких. Старший среди сержантов, но ещё не старшина.'
  },
  {
    id: 6,
    image: '/tickets/land_miliraty_rangs/petty_officer.png',
    question: 'Что за ранг?',
    correctAnswer: 'Старшина',
    hint: 'Единственная широкая полоса, но идёт вдоль всего погона, а не поперёк. Хозяин ротного хозяйства.'
  },
  {
    id: 7,
    image: '/tickets/land_miliraty_rangs/ensign.png',
    question: 'Что за ранг?',
    correctAnswer: 'Прапорщик',
    hint: 'Две маленькие звёздочки одна под другой, но без красных полосок-просветов. Между сержантами и офицерами — особый статус.'
  },
  {
    id: 8,
    image: '/tickets/land_miliraty_rangs/senior_ensign.png',
    question: 'Что за ранг?',
    correctAnswer: 'Старший прапорщик',
    hint: 'Три маленькие звёзды вертикальным рядом. Высшая точка для тех, кто не пошёл в офицеры.'
  },
  {
    id: 9,
    image: '/tickets/land_miliraty_rangs/junior_lieutenant.png',
    question: 'Что за ранг?',
    correctAnswer: 'Младший лейтенант',
    hint: 'Одна звёздочка на единственной красной полоске. Самый первый офицерский чин — только начался путь командира.'
  },
  {
    id: 10,
    image: '/tickets/land_miliraty_rangs/lieutenant.png',
    question: 'Что за ранг?',
    correctAnswer: 'Лейтенант',
    hint: 'Две звёздочки по бокам от красной полоски. Уже не новичок среди офицеров, но ещё в начале пути.'
  },
  {
    id: 11,
    image: '/tickets/land_miliraty_rangs/senior_lieutenant.png',
    question: 'Что за ранг?',
    correctAnswer: 'Старший лейтенант',
    hint: 'Три звёздочки треугольником на одном просвете. Последний шаг перед капитанским званием.'
  },
  {
    id: 12,
    image: '/tickets/land_miliraty_rangs/captain.png',
    question: 'Что за ранг?',
    correctAnswer: 'Капитан',
    hint: 'Четыре звёздочки на единственной полоске — максимум для младших офицеров. Командир роты, вершина младшего офицерского состава.'
  },
  {
    id: 13,
    image: '/tickets/land_miliraty_rangs/major.png',
    question: 'Что за ранг?',
    correctAnswer: 'Майор',
    hint: 'Одна крупная звезда между двумя красными полосками. Первый из старших офицеров — переход на новый уровень.'
  },
  {
    id: 14,
    image: '/tickets/land_miliraty_rangs/lieutenant_colonel.png',
    question: 'Что за ранг?',
    correctAnswer: 'Подполковник',
    hint: 'Две крупные звезды на двух просветах. Заместитель командира полка или командир батальона.'
  },
  {
    id: 15,
    image: '/tickets/land_miliraty_rangs/colonel.png',
    question: 'Что за ранг?',
    correctAnswer: 'Полковник',
    hint: 'Три крупные звезды треугольником на двух просветах. Элита старших офицеров, командир полка.'
  },
  {
    id: 16,
    image: '/tickets/land_miliraty_rangs/major_general.png',
    question: 'Что за ранг?',
    correctAnswer: 'Генерал-майор',
    hint: 'Одна крупная звезда и красная кайма по всему краю погона. Первый генеральский чин — вход в высший офицерский состав.'
  },
  {
    id: 17,
    image: '/tickets/land_miliraty_rangs/lieutenant_general.png',
    question: 'Что за ранг?',
    correctAnswer: 'Генерал-лейтенант',
    hint: 'Две крупные звезды одна над другой с красной окантовкой погона. Командир корпуса, вторая ступень генеральской лестницы.'
  },
  {
    id: 18,
    image: '/tickets/land_miliraty_rangs/colonel_general.png',
    question: 'Что за ранг?',
    correctAnswer: 'Генерал-полковник',
    hint: 'Три крупные звезды вертикальным рядом с красной каймой. Почти вершина военной карьеры, командующий армией.'
  },
  {
    id: 19,
    image: '/tickets/land_miliraty_rangs/army_general.png',
    question: 'Что за ранг?',
    correctAnswer: 'Генерал армии',
    hint: 'Одна огромная звезда с особым знаком над ней и красной окантовкой. Высшее звание для профессионального военного, ниже только Маршал.'
  },
  {
    id: 20,
    image: '/tickets/land_miliraty_rangs/RF_marshal.png',
    question: 'Что за ранг?',
    correctAnswer: 'Маршал РФ',
    hint: 'Одна звезда особого образца с государственным гербом над ней. Самое высокое воинское звание в современной России — редкость и исключительная честь.'
  }
];

function shuffle(arr) {
  return [...arr].sort(() => Math.random() - 0.5);
}

export function generateQuiz(data) {
  const shuffledTickets = shuffle(data);
  const allCorrectAnswers = data.map(t => t.correctAnswer);

  return shuffledTickets.map(ticket => {
    const distractors = shuffle(allCorrectAnswers.filter(a => a !== ticket.correctAnswer)).slice(0, 2);
    const answers = shuffle([ticket.correctAnswer, ...distractors]).map((text, i) => ({
      id: i,
      text,
      isCorrect: text === ticket.correctAnswer
    }));
    return { ...ticket, answers };
  });
}
